/* index.js */

"use strict";

const Steve = require("@gluenetworks/steve_core").getInstance();
const Registrations = require("./Registrations");
const WizardExecutionViewComponent = require("@gluenetworks/wizard_view").views.WizardExecutionView;

module.exports = {
    WizardInstanceEditor: require("./WizardInstanceEditorComponent"),
    actions: {
        NavigateToExecutionViewAction: require("./actions/NavigateToExecutionViewAction"),
    },
};

/****************************************************/
/* START REGISTRATIONS */
/****************************************************/
//WIE Editor
Steve.di.registry.register(
    Registrations.WIZARD_INSTANCE_EDITOR,
    module.exports.WizardInstanceEditor
);

//WIE Execution View
Steve.di.registry.register(
    Registrations.WIZARD_INSTANCE_EDITOR_EXECUTION_VIEW,
    WizardExecutionViewComponent
);

//WIE Navigate to Execution Action
Steve.di.registry.register(
    Registrations.WIZARD_INSTANCE_EDITOR_NAVIGATE_TO_EXECUTION_VIEW_ACTION,
    module.exports.actions.NavigateToExecutionViewAction
);
/****************************************************/
/* END REGISTRATIONS */
/****************************************************/
